import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import { HiOutlineCog6Tooth } from "react-icons/hi2";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { MdOutlineWbSunny } from "react-icons/md";
import { BsMoonFill } from "react-icons/bs";

const Header = ({ toggleSidebar, setDarkMode, darkMode }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const closeDropdown = () => setDropdownOpen(false);

  const handleThemeToggle = () => {
    const newMode = !darkMode;
    localStorage.setItem("theme", newMode ? "dark" : "light");
    setDarkMode(newMode);
  };

  return (
    <header className="dark:bg-[#262626] bg-white text-black dark:text-white px-4 py-3 flex items-center justify-between shadow-sm dark:shadow-2xl">
      <div className="flex items-center gap-4">
        {/* <button onClick={toggleSidebar} className="md:hidden text-2xl">
          <FiMenu />
        </button> */}
        <h1 className="text-lg font-semibold">SmartStart AI</h1>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={handleThemeToggle}
          className="rounded-full bg-gray-200 dark:bg-white w-[30px] h-[30px] text-base focus:outline-none text-gray-800 flex items-center justify-center"
        >
          {darkMode ? <BsMoonFill /> : <MdOutlineWbSunny />}
        </button>

        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="relative z-10 flex items-center justify-center overflow-hidden rounded-full bg-white w-[30px] h-[30px] text-base focus:outline-none text-gray-800"
          >
            <img
              className="w-full h-full object-cover"
              src="/images/jake square.jpg"
              alt="User Avatar"
            />
          </button>

          {dropdownOpen && (
            <>
              <div
                onClick={closeDropdown}
                className="fixed inset-0 h-full w-full z-10"
              ></div>

              <div
                className="absolute right-0 mt-2 bg-white dark:bg-[#0a0a0a] rounded-md shadow-lg overflow-hidden z-20 py-2 px-[2px] space-y-[4px] border border-[#a3a3a3]"
                style={{ width: "10rem" }}
              >
                {/* <Link
                  to="#"
                  className="flex items-center w-full gap-2 text-black dark:text-white text-base font-medium py-2 px-3 hover:bg-[#eaeaea] dark:hover:bg-[#404040]"
                >
                  <HiOutlineCog6Tooth />
                  Settings
                </Link> */}
                <Link
                  onClick={() => {
                    localStorage.removeItem("userData");
                    window.history.pushState({}, "", `/`);
                    window.location.reload();
                  }}
                  className="flex items-center w-full gap-2 text-black dark:text-white text-base font-medium py-2 px-3 hover:bg-[#eaeaea] dark:hover:bg-[#404040]"
                >
                  <RiLogoutCircleRLine />
                  Logout
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
